import React from 'react'

const Uses = () => {
    return (
        <>
            <div className="page-single-post" style={{marginTop:"-30px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="post-content">
                                <div className="post-entry">
                                    <h2 className="wow fadeInUp" data-wow-delay="0.8s" style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeInUp' }}>Uses of CND Mahua Shakti Blend</h2>
                                    <p className="wow fadeInUp" data-wow-delay="1s" style={{ visibility: 'visible', animationDelay: '1s', animationName: 'fadeInUp' }}>This product is primarily used as a daily nutritional food supplement. Based on the ingredients and label, it can be used to:</p>
                                    <ul className="wow fadeInUp" data-wow-delay="1.2s" style={{ visibility: 'visible', animationDelay: '1.2s', animationName: 'fadeInUp' }}>
                                        <li> Add plant-based protein to the diet, from ingredients such as peanuts, chickpeas, almonds, cashews, and seeds.</li>
                                        <li> Provide energy through nuts, seeds, dates, and mahua.</li>
                                        <li> Increase dietary fibre, particularly from flaxseed, chickpeas, and other plant ingredients.</li>
                                        <li> Supplement the diet with nuts and seeds, which provide various naturally occurring nutrients and fats.</li>
                                        <li> Serve as a convenient breakfast or snack addition when mixed with milk, yogurt, porridge, or a smoothie. </li>
                                        <li> Support general nutrition as part of a balanced diet. </li>
                                        <li> Recommended use on the package: 20–30 g daily with milk or as preferred.</li>
                                    </ul>
                                    <blockquote className="wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                        <p>It should be considered a nutritional food product, not a medicine or treatment for a disease.</p>
                                    </blockquote>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Uses
